<template>
  <div>
    <span class="text-body-2 d-flex justify-center mb-4 mt-n5 w-100">
      <vac ref="orderTimer" :left-time="leftTime" @finish="dialog = true">
        <template v-slot:process="{ timeObj }">
          <span>{{ `Time Remaining: ${timeObj.m}:${timeObj.s}` }}</span>
        </template>
        <template v-slot:finish>
          <span>Your Order Has Expired</span>
        </template>
      </vac>
    </span>
    <more-time-modal
      v-if="activeOrder"
      v-model="dialog"
      @close-dialog="dialog = false"
      @more-time="moreTime"
    ></more-time-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import MoreTimeModal from './Components/MoreTimeModal.vue';

export default {
  name: 'OrderExpirationTimer',
  components: {
    MoreTimeModal
  },
  data() {
    return {
      dialog: false
    };
  },
  computed: {
    ...mapGetters('cartOrders', {
      activeOrder: 'active',
      existingOrderItem: 'existingOrderItem'
    }),
    ...mapState('cartOrders', ['orderTimer', 'leftTime'])
  },
  methods: {
    ...mapActions('cartOrders', ['orderExpired']),

    async moreTime($event) {
      await this.orderExpired({
        orderId: this.activeOrder.id,
        itemType: `order_${this.existingOrderItem.parent.type}s`, // TODO hard coded for products for now
        itemId: this.existingOrderItem.id,
        moreTime: $event
      });

      if ($event) this.$refs.orderTimer.startCountdown(true);
      else {
        this.$router.push({
          name: 'Rewards',
          query: {
            t: this.$route.query.t
          }
        });
      }
    }
  }
};
</script>
